import { render } from "./GlobalIcon.vue?vue&type=template&id=7ed286ec"
import script from "./GlobalIcon.vue?vue&type=script&lang=js"
export * from "./GlobalIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/GlobalIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ed286ec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ed286ec', __exports__)) {
    api.reload('7ed286ec', __exports__)
  }
  
  module.hot.accept("./GlobalIcon.vue?vue&type=template&id=7ed286ec", () => {
    api.rerender('7ed286ec', render)
  })

}


export default __exports__